export default __webpack_public_path__ + "static/media/ISSO CLASS-9_SYLLABUS_2025-26.d16cbb65.pdf";